<template>
  <div>
    <div class="right_font"><span @click="addPlugin" class="icon-portal-plus-small plugin_title"></span></div>
    <div v-for="(item, index) in pluginNames" :key="index" class="mt8 plugins">
      <span class="plugin_title mr8">插件名</span>
      <el-input
        class="mr16"
        style="width: 168px"
        :value="item"
        @input="changePluginName(index, $event)"
        placeholder="请输入插件名"
      ></el-input>
      <span @click="delPlugin(index)" class="plugin_title icon-portal-delete"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: { options: Object },
  computed: {
    pluginNames: {
      get() {
        return this.options.chartOption.pluginNames
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.pluginNames", false)
      }
    }
  },
  mounted() {},
  methods: {
    addPlugin() {
      this.$changeOptionsEV("", "chartOption.pluginNames." + this.pluginNames.length, false)
    },
    changePluginName(index, name) {
      this.$changeOptionsEV(name, "chartOption.pluginNames." + index, false)
    },
    delPlugin(index) {
      const pluginNames = [...this.pluginNames]
      pluginNames.splice(index, 1)
      this.$changeOptionsEV(pluginNames, "chartOption.pluginNames", false)
    }
  }
}
</script>

<style scoped>
.plugin_title {
  display: inline-block;
}
.plugin_title:hover {
  cursor: pointer;
}
.plugins {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>
